module.exports = __webpack_public_path__ + "static/media/preview_stamp_campaign_details_page_task_startted_instruction.2246e5f7.svg";